// extracted by mini-css-extract-plugin
export default {"fieldContainer":"MoveCategoryModal_fieldContainer__r4ZNA","label":"MoveCategoryModal_label__WNdJB"};